import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/not-found.css';

const NotFound = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <div className="error-code">404</div>
        <h1>Page Not Found</h1>
        <p>Sorry, the page you're looking for doesn't exist.</p>
        
        <div className="not-found-illustration">
          <i className="fas fa-search"></i>
        </div>
        
        <div className="not-found-actions">
          <Link to="/" className="btn btn-primary">
            <i className="fas fa-home"></i> Go Back Home
          </Link>
        </div>

        <div className="quick-links">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="/#about">About Me</a></li>
            <li><a href="/#skills">Skills</a></li>
            <li><a href="/#projects">Projects</a></li>
            <li><a href="/#contact">Contact</a></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
